import { FormFieldTypes } from "../../../data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";
// import { GridColumnType } from "../../../data/gridColumnType";

export const VerifiedCompetencySubmissionData = {
  name: "ManualAccountTaskList",
  initialState: {
    name: "",
    gmpNumber: "",
    status: 0,
    verifiedCompetencies: 0,
    submittedDateFrom: "",
    submittedDateTo: ""
  },
  formFields: [
    {
      id: "name",
      lable: "Search by Name/Email",
      Field_Name: " Search by Name/Email",
      fieldType: FormFieldTypes.INPUT,
      dataField: "name",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "gmpNumber",
      lable: "Search by GMP Number",
      Field_Name: " Search by GMP Number",
      fieldType: FormFieldTypes.INPUT,
      dataField: "gmpNumber",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "status",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "status",
      fieldSetting: {
        placeholder: " ",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "verifiedCompetencies",
      lable: "Verified Competencies",
      Field_Name: "Verified Competencies",
      fieldType: FormFieldTypes.SELECT,
      dataField: "verifiedCompetencies",
      fieldSetting: {
        placeholder: " ",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "submittedDateFrom",
      lable: "Submitted Date From",
      Field_Name: "Submitted Date From",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "submittedDateFrom",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "submittedDateTo",
      lable: "Submitted Date To",
      Field_Name: "Submitted Date To",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "submittedDateTo",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};

export const VerifiedCompetencyConfig = {
  columns: [
    {
      name: "Name",
      fieldName: "name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "GMP Number",
      fieldName: "gmApNumber",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "verifiedCompetency",
      fieldName: "verfiedCompetencyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Submitted Date",
      fieldName: "createdAt",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD MMM YYYY",
      },
    },
    {
      name: "Status",
      fieldName: "statusName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
      },
    },
  ],
};
